module.exports = "/static/assets/5acd13d114f21425b81ad9feba3dca63.png";